import React from "react";
import { useParams } from "react-router-dom";
import { MercoaSession } from "@mercoa/react";
import ReceivableInvoiceDetails from "../accounts_receivable/ReceivableInvoiceDetails";
import PayableInvoiceDetails from "../accounts_payable/PayableInvoiceDetails";

/**
 *
 * @param {string} invoiceType either "receivable" or "payable"
 * @returns an authenticated mercoa session with a child invoice details component
 */
const InvoiceDetailsSession = ({ invoiceType }) => {
  const { entityId, invoiceId } = useParams();
  const mercoaToken = localStorage.getItem("mercoa_token");

  return (
    <MercoaSession token={mercoaToken} entityId={entityId}>
      {invoiceType.toLowerCase() === "receivable" && (
        <ReceivableInvoiceDetails invoiceId={invoiceId} />
      )}
      {invoiceType.toLowerCase() === "payable" && (
        <PayableInvoiceDetails invoiceId={invoiceId} />
      )}
    </MercoaSession>
  );
};

export default InvoiceDetailsSession;
